import type { HelpFile } from '../../types/help'
import { DesignerToolbarTestIds } from '../../../testids/DesignerToolbarTestIds'

export const designerToolbarHelp: HelpFile = {
  docPage: '/docs/admin/form-layout-designer',
  texts: {
    [DesignerToolbarTestIds.designerToolbarTitle]: null,
    [DesignerToolbarTestIds.designerPreviewBtn]:
      'In den Vorschaumodus wechseln, um das Layout so zu sehen, wie es in der Anwendung dargestellt wird.',
  },
}
